import * as tslib_1 from "tslib";
import { getItem } from '../../utils/getItem';
import { ComposeTarget, lazyLoadDraftToCompose } from 'owa-mail-compose-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { lazyMoveReadingPaneToTab } from 'owa-mail-reading-pane-store';
import { loadItem } from 'owa-mail-store-actions';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
export function displayMessageForm(itemId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var item, clientItemId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    item = getItem(itemId);
                    if (!(!item || !item.NormalizedBody)) return [3 /*break*/, 2];
                    clientItemId = {
                        Id: itemId,
                        mailboxInfo: getMailboxInfo(getSelectedTableView()),
                    };
                    return [4 /*yield*/, loadItem(clientItemId, 'LoadItemReadingPane')];
                case 1:
                    item = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!item.IsDraft) return [3 /*break*/, 4];
                    return [4 /*yield*/, openComposeItem(itemId)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, openReadItem(item)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
export function openReadItem(item) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var table, mailboxInfo, conversationId, itemId;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isTabViewEnabled()) return [3 /*break*/, 4];
                    table = getSelectedTableView();
                    mailboxInfo = getMailboxInfo(table);
                    if (!(table.tableQuery.listViewType === 0 /* Conversation */)) return [3 /*break*/, 2];
                    conversationId = tslib_1.__assign({}, item.ConversationId, { mailboxInfo: mailboxInfo });
                    return [4 /*yield*/, lazyMoveReadingPaneToTab.importAndExecute(conversationId, item.Subject, item.Categories, false /* makeActive */, null)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(table.tableQuery.listViewType === 1 /* Message */)) return [3 /*break*/, 4];
                    itemId = tslib_1.__assign({}, item.ItemId, { mailboxInfo: mailboxInfo });
                    return [4 /*yield*/, lazyMoveReadingPaneToTab.importAndExecute(itemId, item.Subject, item.Categories, false /* makeActive */, null)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function openComposeItem(itemId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMailFeatureEnabled('rp-popouts')) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyLoadDraftToCompose.importAndExecute(itemId, ComposeTarget.Popout)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=DisplayMessageFormAdapter.js.map